export const calculateAndConvertTotalVolume = (numbers: (string | number)[]): number => {
  const parsedNumbers = numbers
    ?.map((num) => {
      const parsed = parseFloat(num as string);

      return Number.isNaN(parsed) ? 0 : parsed;
    })
    .filter((num) => num !== 0);

  if (parsedNumbers.length === 0) return 0;

  return parsedNumbers.reduce((total, num) => total + num, 0);
};
